/*
 * NDL Cart Upsell — Chevron-Carousel + Add-to-Cart mit Section-Refresh.
 * Variante ohne Swiper (keine Infinite-Loop) — CSS-Scroll-Snap reicht.
 */
(function () {
  'use strict';

  /* ── Overflow-Detection: fügt .has-overflow auf .ndl-drawer__upsells hinzu,
     wenn der Track tatsächlich horizontal scrollen muss. Die CSS-Regeln
     nutzen die Klasse, um Chevrons einzublenden und den Track von center
     auf flex-start zu schalten. ── */
  function updateOverflowState(root) {
    var track = root && root.querySelector('[data-ndl-upsell-track]');
    if (!track) return;
    // +1 als Toleranz für Sub-Pixel-Rundungsfehler in Browsern.
    var hasOverflow = track.scrollWidth > track.clientWidth + 1;
    root.classList.toggle('has-overflow', hasOverflow);
  }

  function scanAllCarousels() {
    document.querySelectorAll('[data-ndl-upsell-carousel]').forEach(updateOverflowState);
  }

  var resizeObserver = null;
  function observeCarousels() {
    if (typeof ResizeObserver === 'undefined') {
      // Fallback ohne ResizeObserver: nur bei Resize / Cart-Update neu rechnen.
      return;
    }
    if (!resizeObserver) {
      resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var root = entry.target.closest('[data-ndl-upsell-carousel]');
          if (root) updateOverflowState(root);
        });
      });
    }
    document.querySelectorAll('[data-ndl-upsell-carousel] [data-ndl-upsell-track]').forEach(function (track) {
      try { resizeObserver.observe(track); } catch (e) { /* ignore */ }
    });
  }

  function boot() {
    scanAllCarousels();
    observeCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('resize', scanAllCarousels);

  // Nach Cart-Re-Render neu initialisieren (Markup wurde ausgetauscht).
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(boot, 30);
    });
  }
  document.addEventListener('quantity-rules:corrected', function () {
    setTimeout(boot, 30);
  });

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function refreshCartSections(sections) {
    if (!sections) return;

    // Drawer (cart-drawer Section im Layout)
    if (sections['cart-drawer']) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        var inner = getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
        var target = document.querySelector('#CartDrawer');
        if (target && inner) {
          target.innerHTML = inner;
          cartDrawer.classList.remove('is-empty');
        }
      }
    }

    // Cart-Icon-Bubble in der Header-Navigation
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var inner2 = getSectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
        if (inner2) {
          bubble.innerHTML = inner2;
        } else {
          var fallback = getSectionInnerHTML(sections['cart-icon-bubble'], '#cart-icon-bubble');
          if (fallback) bubble.innerHTML = fallback;
        }
      }
    }

    // Cart-Page: main-cart-items
    if (sections['main-cart-items']) {
      var cartItems = document.querySelector('cart-items');
      if (cartItems) {
        var innerCi = getSectionInnerHTML(sections['main-cart-items'], 'cart-items');
        if (innerCi) {
          cartItems.innerHTML = innerCi;
          cartItems.classList.toggle('is-empty', innerCi.indexOf('cart__warnings') > -1);
        } else {
          var fallbackCi = getSectionInnerHTML(sections['main-cart-items'], '.js-contents');
          var main = document.getElementById('main-cart-items');
          var jsContents = main && main.querySelector('.js-contents');
          if (fallbackCi && jsContents) jsContents.innerHTML = fallbackCi;
        }
      }
    }

    // Cart-Page: main-cart-footer
    if (sections['main-cart-footer']) {
      var footer = document.getElementById('main-cart-footer');
      if (footer) {
        var innerFt = getSectionInnerHTML(sections['main-cart-footer'], '.js-contents');
        var target2 = footer.querySelector('.js-contents') || footer;
        if (innerFt) target2.innerHTML = innerFt;
      }
    }

    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ndl-cart-upsell' });
    }
  }

  /* ── Chevron-Navigation ── */
  document.addEventListener('click', function (e) {
    var carousel = e.target.closest('[data-ndl-upsell-carousel]');
    if (!carousel) return;
    var track = carousel.querySelector('[data-ndl-upsell-track]');
    if (!track) return;

    var prev = e.target.closest('.ndl-drawer__upsell-prev');
    var next = e.target.closest('.ndl-drawer__upsell-next');

    if (prev) {
      e.preventDefault();
      var card1 = track.querySelector('.ndl-upsell-card');
      var w1 = card1 ? card1.offsetWidth + 16 : 280;
      track.scrollBy({ left: -w1, behavior: 'smooth' });
    } else if (next) {
      e.preventDefault();
      var card2 = track.querySelector('.ndl-upsell-card');
      var w2 = card2 ? card2.offsetWidth + 16 : 280;
      track.scrollBy({ left: w2, behavior: 'smooth' });
    }
  });

  /* ── Add-to-Cart ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ndl-upsell-card__add');
    if (!btn || btn.disabled) return;
    var drawer = btn.closest('cart-drawer');
    if (!drawer) return;

    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    var productId = btn.getAttribute('data-product-id');
    if (!variantId) return;

    // Respekt der Quantity-Regeln aus custom.mindestabnahmemenge (Default 1)
    var qty = 1;
    if (productId && window.QuantityRules && window.QuantityRules[productId]) {
      qty = parseInt(window.QuantityRules[productId].min, 10) || 1;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var sectionsUrl = typeof window.location.pathname === 'string' ? window.location.pathname : '/';

    // Sections: welche wir zurück haben wollen. Wir requesten alle für Drawer
    // UND Cart-Page — der Refresh-Code ignoriert ungerenderte Ziele still.
    var wantedSections = 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: qty }],
        sections: wantedSections,
        sections_url: sectionsUrl,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status === 422 || (data.status && data.status >= 400)) {
          console.warn('Cart add rejected:', data);
          return;
        }
        if (data.sections) {
          refreshCartSections(data.sections);
        }
      })
      .catch(function (err) {
        console.error('NDL upsell add-to-cart failed:', err);
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = originalText;
      });
  });
})();
